import { View, Accordion, Disclosure, DisclosureTitle, DisclosurePanel, Flex, ComboBox, TagGroup, TextField, Divider, Link, DatePicker, Checkbox, ActionButton, ToastQueue } from '@adobe/react-spectrum';
import { Item } from '@react-stately/collections';
import React, { useEffect, useRef, useState } from 'react';
import { ContactFormData } from '../AddNewPerson';
import { useDependency } from '../../../../../contexts/DependencyProvider';
import CompanyDropDown from '../formComponents/CompaniesDropDown';
import { truncateText } from '../../../../../utils/helperUtil';
import { CloseIcon, EditIcon } from '../../../../../components/protected/Icons/IconsLib';
import PositionDropDown from '../formComponents/PositionDropDown';
import DepartmentDropDown from '../formComponents/DepartmentDropDown';
import { CalendarDate,parseDate } from '@internationalized/date';
import moment from 'moment';
import { Check, ExclamationTriangle, Plus } from 'react-bootstrap-icons';
import { useViewInfo } from '../../../../../hooks/UseViewInfo';
import { DeleteConfirmationDialog } from '../../../finder/components/DeleteConfirmationDialog';
import { DeleteCompanyPersonRelationRequest } from '../../../../../services/soap/main/requests/DeleteCompanyPersonRelationRequest';
import { useTranslation } from 'react-i18next';

interface IEmploymentSectionProps{
  data: ContactFormData['employments'];
  onChange: (data: ContactFormData['employments']) => void;
  onAdd: (employeement:any) => void;
  onUpdate:(employeement:any,index:number) => void;
  expandedSectionKey:any
  setExpandedSectionKey:(data:any)=>void;
  validationErrors:any
  setValidationErrors : (data:any)=>void;
  fieldConfig:any
  validationStatus:any
  setValidationStatus:(data:any)=>void;
}
export const EmploymentSection: React.FC<IEmploymentSectionProps> = ({ 
  data,
  onChange,
  onAdd,
  onUpdate,
  expandedSectionKey,
  setExpandedSectionKey,
  validationErrors,
  setValidationErrors,
  fieldConfig,
  validationStatus,
  setValidationStatus }) => {
  const [expandedSections, setExpandedSections] = useState<Set<number>>(new Set());
  const [isSectionRequired,setIsSectionRequired] = useState(false);
  const [selectedEmployee,setSelectedEmployee] = useState<any>();
  const [selectedIndex,setSelectedIndex] = useState<any>();
  const [isOpen,setIsOpen] = useState(false);
  const{store,mainService} = useDependency();
  const{isMobile} = useViewInfo();
    const handleSelectionChange = (company: any, index: number,mode:string) => {
      if (mode === "update") {
        onUpdate(company,index);
      } 
      else{
        onAdd(company);
      }
    };

  const onRemove = (company:any,index:number) => {
    setIsOpen(true)
    setSelectedEmployee(company)
    setSelectedIndex(index)
  };

  const buttonRef = useRef<any>(null);
      useEffect(() => {
      if (expandedSectionKey?.has?.("employmentSection")) {
        setTimeout(() => {
          buttonRef.current?.focus();
        }, 200); 
      }
    }, [expandedSectionKey]);

  const handleDeleteCompanyRelation = async ()=>{
    const updatedContacts = data.filter((_, i) => i !== selectedIndex);
    setExpandedSections((prev) => {
      const newSet = new Set(prev);
      newSet.delete(selectedIndex);
      return newSet;
    }); 

    onChange(updatedContacts); 
      if(selectedEmployee.id){
        const result = await mainService.deleteCompanyPersonRelation(new DeleteCompanyPersonRelationRequest(store.Server,store.SessionId,{
        id:selectedEmployee.id
      }))

      if(result.result !== 'OK'){
        ToastQueue.negative(result.EXCEPTION.message,{timeout:300})
      }
    }
  }

  const onEdit = (data:any,index:number)=>{
    setExpandedSections((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(index)) {
        newSet.delete(index);
      } else {
        newSet.add(index);
      }
      return newSet;
    });
  }

  const updatePrimary = (value: boolean, index: number) => {
    const primaryCount = data.filter(item => item.isPrimary).length;
    if (!value && primaryCount === 1) {
      return;
    }
    const newData = data.map((item, i) => ({
      ...item,
      isPrimary: i === index ? value : false,
    }));
    onChange(newData);
  };

  const handleSectionExpandedChange = () => {
    setExpandedSectionKey((prevKey:any) => prevKey.has("employmentSection") ? new Set() : new Set(["employmentSection"]));
  };
  
  const handleConfirm = ()=>{
    setExpandedSectionKey(new Set(['imageUploadSection']))
  }
  const { t } = useTranslation('contacts');
  const _t = (key: string) => t(`addNewPerson.${key}`, { ns: 'contacts' });
  const _tt = (key: string) => t(`contact_common.${key}`, { ns: 'contacts' });
  return(
    <Accordion isQuiet expandedKeys={expandedSectionKey} onExpandedChange={handleSectionExpandedChange}>
      <Disclosure id="employmentSection"> 
        <DisclosureTitle>
        <Flex justifyContent="space-between" alignItems="center" width="100%">
                          <View><span>{_t(`employments`)}</span><span style={{color:'#B0BEC5',fontFamily:'Adobe Clean'}}>{isSectionRequired && ` (${_tt('required')})`}</span></View>
                           {validationStatus.employmentSection ? <Check size={20} color="#1976D2" /> :<ExclamationTriangle size={20} color="#FF9800" />}
                        </Flex>
          
        </DisclosureTitle>
        <DisclosurePanel>
        <Divider size='M' UNSAFE_style={{marginBottom:10}}/>
          <Flex direction="column" gap="size-100" width='100%'>
            {data.map((tag, index) => ( 
              <View>
              <Flex key={index} gap="size-100" direction={{base:'column',L:'row'}} width='100%'>
                 <CompanyDropDown
                    onChange={(data,idx)=>{
                      handleSelectionChange(data,index,"update")
                    }}
                    selectedCompany={tag.company}
                    showLabel
                  />
                  {isMobile?
                  (<Flex direction={'row'} gap={'size-100'}>
                        <TextField 
                    value={tag.positionInfo} 
                    onChange={(description) => { 
                      const newData = [...data]; 
                      newData[index] = { ...tag, positionInfo:description }; 
                      onChange(newData); 
                    }} 
                    width={{base:"100%"}}
                    UNSAFE_style={{marginTop:25}}
                  />
                  <a style={{marginTop:30}} onClick={()=>onEdit(tag,index)}>
                      <EditIcon size={20}/> 
                  </a>
                  <Checkbox UNSAFE_style={{marginTop:25}} isSelected={data[index].isPrimary}
                   onChange={(value)=>updatePrimary(value,index)}></Checkbox>
                  </Flex>):
                  (
                    <>
                        <TextField 
                        value={tag.positionInfo} 
                        onChange={(description) => { 
                          const newData = [...data]; 
                          newData[index] = { ...tag, positionInfo:description }; 
                          onChange(newData); 
                        }} 
                        width={{base:"74%"}}
                        UNSAFE_style={{marginTop:25}}
                      />
                      <a style={{marginTop:26}} onClick={()=>onEdit(tag,index)}>
                          <EditIcon size={20}/> 
                      </a>
                      <Checkbox UNSAFE_style={{marginTop:25}} isSelected={data[index].isPrimary}
                      onChange={(value)=>updatePrimary(value,index)}></Checkbox>
                   </>
                  )
                  }
                  <ActionButton 
                                                 UNSAFE_style={{marginTop:23}}
                                                 isQuiet = {isMobile ? false : true}
                                                 onPress={() => onRemove(tag,index)}
                                 
                                               >
                                                 {isMobile ? _tt('button_remove') : <CloseIcon size={18} />}
                                               </ActionButton>
              </Flex>
              {(expandedSections.has(index) || !!data[index].department) &&(
                  <Flex key={index+1} direction='column'>
                  <Flex direction="row" gap="size-100">
                    <DepartmentDropDown 
                    selectedDepartment={data[index].department ? data[index].department : ''}
                    onChange={(dept)=>{ 
                        const newData = [...data]; 
                        newData[index] = { ...tag, department:dept.id,departmentInfo:dept.name }; 
                        onChange(newData); 
                      }
                    } />
                    <PositionDropDown
                     selectedPosition={data[index].position ? data[index].position : ''}
                     onChange={(position)=>{ 
                        const newData = [...data]; 
                        newData[index] = { ...tag, position:position.id}; 
                        onChange(newData); 
                      }
                    } />
                  </Flex>
                  <Flex direction="row" gap="size-100">
                    <DatePicker 
                    value={data[index].validFrom ? parseDate(moment(data[index].validFrom).toISOString().split("T")[0]) : undefined}
                    onChange={(value)=>{ 
                        if(!value) return;
                        const jsDate = new Date(value.year, value.month - 1, value.day);
                        const newData = [...data];
                        newData[index] = { ...tag, validFrom: moment(jsDate).format('YYYY/MM/DD') };
                        onChange(newData);
                      }
                    } label="Valid From" width="50%" />
                    <DatePicker label="Valid To" width="50%" 
                    value={data[index].validTo ? parseDate(moment(data[index].validTo).toISOString().split("T")[0]) : undefined}
                    onChange={(value)=>{ 
                      if(!value) return;
                      const jsDate = new Date(value.year, value.month - 1, value.day);
                      const newData = [...data];
                      newData[index] = { ...tag, validTo: moment(jsDate).format("YYYY/MM/DD") };
                      onChange(newData);
                    }}
                    />
                  </Flex>
                  </Flex>
              )
              }
              </View>
            ))}
            {data.length > 0 &&
              <Divider size='M' aria-label="" /> 
            }
              
               <Flex direction="row" gap={'size-100'} marginTop={10} justifyContent='space-between'>
               {/* <CompanyDropDown
               onChange={handleSelectionChange}
               showLabel={true} /> */}
                    <View>
                                  <ActionButton ref={buttonRef} onPress={onAdd} isQuiet UNSAFE_style={{color:'#1976D2'}}><Plus size={22} color='#1976D2' /> {_t('button_add_employment')}</ActionButton>
                                </View>
                                <View>
                                  <ActionButton onPress={handleConfirm} isQuiet UNSAFE_style={{color:'#1976D2'}}><Check size={22} color='#1976D2' /> {_tt('button_confirm')}</ActionButton> {/*active:#1976D2, disabled:#B0BEC5*/}
                                </View>
              </Flex>
            </Flex>
            <DeleteConfirmationDialog
                              isOpen={isOpen}
                              onClose={() => setIsOpen(false)}
                              onConfirm={()=>handleDeleteCompanyRelation()}
                              itemName={selectedEmployee?.companyInfo}
                            />
            <Divider size='M' UNSAFE_style={{marginTop:10}}/>
        </DisclosurePanel>
      </Disclosure>
    </Accordion>
);
}
